import React from "react";
import "./sidebar.css"
import AboutMe from "./Aboutme";

function Sidebar() {
    return <div className="sidebar">
    <AboutMe/>
    </div>
}
export default Sidebar;